import { type MutationOptions } from '@tanstack/react-query'

import { w } from '@/lib/api'
import { API_ENDPOINTS } from '@/lib/constants/api'

import { type ReqUpdateCaseExtraInfoMutation } from './types'

export const updateCaseExtraInfoMutation: MutationOptions<unknown, unknown, ReqUpdateCaseExtraInfoMutation> = {
  mutationFn: (payload) => w.post(payload, API_ENDPOINTS.business.v1['case-extra'].index).json(),
}

export const updateCaseInquirySubmissionMutation = {
  mutationFn: (data: { caseId: number; inquirySubmitted?: boolean }): Promise<void> =>
    w.post(data, API_ENDPOINTS.business.v1['case-extra'].process.submit.index).json(),
}

export const updateI485FilingMutation = {
  mutationFn: (data: { caseId: number; visaBulletinSubmitted?: boolean }): Promise<void> =>
    w.post(data, API_ENDPOINTS.business.v1['case-extra'].process.submit.index).json(),
}
